import { useEffect, useState } from "react"
import { UsageView } from "../../views"
import { UsageService } from "../../../services"
import moment from "moment"

const UsageAction = () =>{
  const url = process.env.REACT_APP_ETICKET_API
  const usageService = new UsageService(url)
  const token = JSON.parse(localStorage.getItem('token')).accessToken
  const chatbotUrl = process.env.REACT_APP_CHATBOT_URL
  console.log("Chatbot URL:", chatbotUrl)
  
  const [usagePart1, setUsagePart1] = useState(null)
  const [dataConversations, setDataConversations] = useState(null)
  const [dailyTokenUsage, setDailyTokenUsage] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  const [isLoadingChangePage, setIsLoadingChangePage] = useState(false)
  const [date, setDate] = useState(parseInt(moment().format('YYYYMM')))

  const monthYearOptions = Array.from({ length: 12 }, (_, i) => {
        const monthDate = moment().subtract(i, 'months')
        const value = parseInt(monthDate.format('YYYYMM'))
        return {
            value,
            text: monthDate.format('MMMM YYYY')
        }
    }).reverse()
  // const [dates, setDates] = useState({ startDate: moment().subtract(1, 'year').toDate(), endDate: moment().toDate()})
  // const [periodType, setPeriodType] = useState("year") // "year" | "month" | "week" | "day"

    const handleChangeDate = (event) => {
        setDate(event.target.value.value)
    }

  const getData = async () => {
    try {
      const monthNumber = date % 100
      const yearNumber = Math.floor(date / 100)

      // Fetching usage data
      const [usagePart1P, conversationsByMonthP, dailyTokenUsageP] = await Promise.all([
            usageService.getUsagePart1Passthrough(yearNumber, monthNumber, token),
            usageService.getConversationsByDateAndPageLimit(yearNumber, monthNumber, token, null, 1, 10),
            usageService.getDailyTokenUsage(yearNumber, monthNumber, token),
          ])

      setUsagePart1(usagePart1P)
      setDataConversations(conversationsByMonthP)
      setDailyTokenUsage(dailyTokenUsageP)
      setIsLoading(false)
    } catch (error) {
      console.error("Error in UsageAction:", error)
    }
  }

  useEffect(() => {
    getData()
  }, [date])
  
  /**
   * @description method to get paginated conversation
   * @param page page number
   * @param limit number of registers by page
   */
  const handleGetPaginatedConversation = async (page, limit, sort = null) => {
    try {
      setIsLoadingChangePage(true)
      const monthNumber = date % 100
      const yearNumber = Math.floor(date / 100)

      const response = await usageService.getConversationsByDateAndPageLimit(yearNumber, monthNumber, token, null, page, limit, sort)
      setDataConversations(response)
      setIsLoadingChangePage(false)
    } catch (error) {
      console.error(`An error has ocurred in usageAction: ${error}`)
      setIsLoadingChangePage(false)
    }
  }

  return (
    <UsageView 
      isLoading={isLoading}
      isLoadingChangePage={isLoadingChangePage}
      usagePart1={usagePart1}
      dataConversations={dataConversations}
      dailyTokenUsage={dailyTokenUsage}
      date={date}
      handleChangeDate={handleChangeDate}
      monthYearOptions={monthYearOptions}
      chatbotUrl={chatbotUrl}
      handleGetPaginatedConversation={handleGetPaginatedConversation}
    />
  )
}

export { UsageAction as default }